module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAeElEQVR4AWMYNOA/OZh6Bvx/zvCfDIww4J4lx390fN9H6f++6c3/r29f/v+ev+p/LGrwG/D73vX/E6bN+H/l4qX/fx7fw28ANv9duXr9/4atO/73xgb9v7Z5DemBKC0t/X/9ug3/N69d+19ORoYOgUgGHgwGDA8AAJs+MT1y3+N/AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/UG.png
// module id = 1291
// module chunks = 0